export default __webpack_public_path__ + "static/media/banner-acidentes-pessoais.93caa44a.png";